// extracted by mini-css-extract-plugin
export default {"NameContainer":"NameInput_NameContainer__MHwTB","Title":"NameInput_Title__QAt5Z","NameInput":"NameInput_NameInput__LnKt1","InputError":"NameInput_InputError__GC24m"};